import { graphql } from "gatsby"

import { CoreParagraphBlockFragment } from "../components/blocks/CoreParagraphBlock/" // eslint-disable-line
import { CoreHeadingBlockFragment } from "../components/blocks/CoreHeadingBlock/" // eslint-disable-line
import { CoreColumnBlockFragment } from "../components/blocks/CoreColumnBlock/" // eslint-disable-line
import { CoreColumnsBlockFragment } from "../components/blocks/CoreColumnsBlock/" // eslint-disable-line
import { CoreImageBlockFragment } from "../components/blocks/CoreImageBlock/" // eslint-disable-line
import { CoreButtonsBlockFragment } from "../components/blocks/CoreButtonsBlock/" // eslint-disable-line
import { CoreButtonBlockFragment } from "../components/blocks/CoreButtonBlock/" // eslint-disable-line
import { CoreGalleryBlockFragment } from "../components/blocks/CoreGalleryBlock/" // eslint-disable-line
import { CgbQuoteBlockFragment } from "../components/blocks/CgbQuoteBlock/" // eslint-disable-line
import { CoreListBlockFragment } from "../components/blocks/CoreListBlock/" // eslint-disable-line
import { CoreListItemBlockFragment } from "../components/blocks/CoreListItemBlock/" // eslint-disable-line
import { CoreTableBlockFragment } from "../components/blocks/CoreTableBlock/" // eslint-disable-line
import { CoreFileBlockFragment } from "../components/blocks/CoreFileBlock/" // eslint-disable-line
import { CoreSpacerBlockFragment } from "../components/blocks/CoreSpacerBlock/" // eslint-disable-line
import { CgbAccordionBlockFragment } from "../components/blocks/CgbAccordionBlock" // eslint-disable-line
import { CgbAccordionInnerBlockFragment } from "../components/blocks/CgbAccordionInnerBlock" // eslint-disable-line
import { CgbBannerCalloutCtaBlockFragment } from "../components/blocks/CgbBannerCalloutCtaBlock" // eslint-disable-line
import { CgbBannerMessageBlockFragment } from "../components/blocks/CgbBannerMessageBlock" // eslint-disable-line
import { CgbBlogPostWrapBlockFragment } from "../components/blocks/CgbBlogPostWrapBlock" // eslint-disable-line
import { CgbBreakoutGalleryIntroBlockFragment } from "../components/blocks/CgbBreakoutGalleryIntroBlock" // eslint-disable-line
import { CgbCalloutCtaBlockFragment } from "../components/blocks/CgbCalloutCtaBlock" // eslint-disable-line
import { CgbCardBlockFragment } from "../components/blocks/CgbCardBlock" // eslint-disable-line
import { CgbCardRowBlockFragment } from "../components/blocks/CgbCardRowBlock" // eslint-disable-line
import { CgbContactBannerBlockFragment } from "../components/blocks/CgbContactBannerBlock" // eslint-disable-line
import { CgbContactFormBlockFragment } from "../components/blocks/CgbContactFormBlock" // eslint-disable-line
import { CgbFileListBlockFragment } from "../components/blocks/CgbFileListBlock" // eslint-disable-line
import { CgbFileListInnerBlockFragment } from "../components/blocks/CgbFileListInnerBlock" // eslint-disable-line
import { CgbFileListInnerSmallBlockFragment } from "../components/blocks/CgbFileListInnerSmallBlock" // eslint-disable-line
import { CgbGoodToGoBlockFragment } from "../components/blocks/CgbGoodToGoBlock" // eslint-disable-line
import { CgbIconListBlockFragment } from "../components/blocks/CgbIconListBlock" // eslint-disable-line
import { CgbIconListIntroBlockFragment } from "../components/blocks/CgbIconListIntroBlock" // eslint-disable-line
import { CgbIconListInnerBlockFragment } from "../components/blocks/CgbIconListInnerBlock" // eslint-disable-line
import { CgbImageSliderBlockFragment } from "../components/blocks/CgbImageSliderBlock" // eslint-disable-line
import { CgbImageBreakdownBlockFragment } from "../components/blocks/CgbImageBreakdownBlock" // eslint-disable-line
import { CgbImageBreakdownInnerBlockFragment } from "../components/blocks/CgbImageBreakdownInnerBlock" // eslint-disable-line
import { CgbImageGalleryGridBlockFragment } from "../components/blocks/CgbImageGalleryGridBlock" // eslint-disable-line
import { CgbImageGalleryGridInnerLargeBlockFragment } from "../components/blocks/CgbImageGalleryGridInnerLargeBlock" // eslint-disable-line
import { CgbImageGalleryGridInnerSmallBlockFragment } from "../components/blocks/CgbImageGalleryGridInnerSmallBlock" // eslint-disable-line
import { CgbImageLinkSliderBlockFragment } from "../components/blocks/CgbImageLinkSliderBlock" // eslint-disable-line
import { CgbImageLinkSliderInnerBlockFragment } from "../components/blocks/CgbImageLinkSliderInnerBlock" // eslint-disable-line
import { CgbIntroGalleryBlockFragment } from "../components/blocks/CgbIntroGalleryBlock" // eslint-disable-line
import { CgbIntroGallerySplitBlockFragment } from "../components/blocks/CgbIntroGallerySplitBlock" // eslint-disable-line
import { CgbIntroImageSliderBlockFragment } from "../components/blocks/CgbIntroImageSliderBlock" // eslint-disable-line
import { CgbLatestPostsBlockFragment } from "../components/blocks/CgbLatestPostsBlock" // eslint-disable-line
import { CgbNextPreviousPostsBlockFragment } from "../components/blocks/CgbNextPreviousPostsBlock" // eslint-disable-line
import { CgbOfferGridBlockFragment } from "../components/blocks/CgbOfferGridBlock" // eslint-disable-line
import { CgbOfferGridInnerBlockFragment } from "../components/blocks/CgbOfferGridInnerBlock" // eslint-disable-line
import { CgbOpeningTimesBlockFragment } from "../components/blocks/CgbOpeningTimesBlock" // eslint-disable-line
import { CgbPullquoteBlockFragment } from "../components/blocks/CgbPullquoteBlock" // eslint-disable-line
import { CgbPubListingBlockFragment } from "../components/blocks/CgbPubListingBlock" // eslint-disable-line
import { CgbSocialSharingBlockFragment } from "../components/blocks/CgbSocialSharingBlock" // eslint-disable-line
import { CgbThinIntroBlockFragment } from "../components/blocks/CgbThinIntroBlock" // eslint-disable-line
import { CgbThickIntroBlockFragment } from "../components/blocks/CgbThickIntroBlock" // eslint-disable-line
import { CgbTwoCardIntroBlockFragment } from "../components/blocks/CgbTwoCardIntroBlock" // eslint-disable-line
import { CgbTwoColIntroBlockFragment } from "../components/blocks/CgbTwoColIntroBlock" // eslint-disable-line
import { CgbBlogPagePostsBlockFragment } from "../components/blocks/CgbBlogPagePostsBlock" // eslint-disable-line
import { CgbVideoBannerMessageBlockFragment } from "../components/blocks/CgbVideoBannerMessageBlock" // eslint-disable-line
import { CgbVideoEmbedBlockFragment } from "../components/blocks/CgbVideoEmbedBlock" // eslint-disable-line
import { CgbAccommodationBannerBlockFragment } from "../components/blocks/CgbAccommodationBannerBlock" // eslint-disable-line
import { CgbAccommodationFeaturedRoomsBlockFragment } from "../components/blocks/CgbAccommodationFeaturedRoomsBlock" // eslint-disable-line
import { CgbAccommodationFeaturedRoomsInnerBlockFragment } from "../components/blocks/CgbAccommodationFeaturedRoomsInnerBlock" // eslint-disable-line
import { CgbAccommodationIntroBlockFragment } from "../components/blocks/CgbAccommodationIntroBlock" // eslint-disable-line
import { CgbAccommodationRoomListBlockFragment } from "../components/blocks/CgbAccommodationRoomListBlock" // eslint-disable-line
import { CgbAccommodationOtherRoomsBlockFragment } from "../components/blocks/CgbAccommodationOtherRoomsBlock" // eslint-disable-line
import { GravityformsFormBlockFragment } from "../components/blocks/GravityformsFormBlock" // eslint-disable-line
import { CgbSignupGateFormFragment } from "../components/blocks/CgbSignupGateFormBlock" // eslint-disable-line

import { CoreParagraphBlockPreview } from "../components/blocks/CoreParagraphBlock/" // eslint-disable-line
import { CoreHeadingBlockPreview } from "../components/blocks/CoreHeadingBlock/" // eslint-disable-line
import { CoreColumnBlockPreview } from "../components/blocks/CoreColumnBlock/" // eslint-disable-line
import { CoreColumnsBlockPreview } from "../components/blocks/CoreColumnsBlock/" // eslint-disable-line
import { CoreImageBlockPreview } from "../components/blocks/CoreImageBlock/" // eslint-disable-line
import { CoreButtonsBlockPreview } from "../components/blocks/CoreButtonsBlock/" // eslint-disable-line
import { CoreButtonBlockPreview } from "../components/blocks/CoreButtonBlock/" // eslint-disable-line
import { CoreGalleryBlockPreview } from "../components/blocks/CoreGalleryBlock/" // eslint-disable-line
import { CgbQuoteBlockPreview } from "../components/blocks/CgbQuoteBlock/" // eslint-disable-line
import { CoreListBlockPreview } from "../components/blocks/CoreListBlock/" // eslint-disable-line
import { CoreListItemBlockPreview } from "../components/blocks/CoreListItemBlock/" // eslint-disable-line
import { CoreTableBlockPreview } from "../components/blocks/CoreTableBlock/" // eslint-disable-line
import { CoreFileBlockPreview } from "../components/blocks/CoreFileBlock/" // eslint-disable-line
import { CoreSpacerBlockPreview } from "../components/blocks/CoreSpacerBlock/" // eslint-disable-line
import { CgbAccordionBlockPreview } from "../components/blocks/CgbAccordionBlock" // eslint-disable-line
import { CgbAccordionInnerBlockPreview } from "../components/blocks/CgbAccordionInnerBlock" // eslint-disable-line
import { CgbBannerCalloutCtaBlockPreview } from "../components/blocks/CgbBannerCalloutCtaBlock" // eslint-disable-line
import { CgbBannerMessageBlockPreview } from "../components/blocks/CgbBannerMessageBlock" // eslint-disable-line
import { CgbBlogPostWrapBlockPreview } from "../components/blocks/CgbBlogPostWrapBlock" // eslint-disable-line
import { CgbBreakoutGalleryIntroBlockPreview } from "../components/blocks/CgbBreakoutGalleryIntroBlock" // eslint-disable-line
import { CgbCalloutCtaBlockPreview } from "../components/blocks/CgbCalloutCtaBlock" // eslint-disable-line
import { CgbCardBlockPreview } from "../components/blocks/CgbCardBlock" // eslint-disable-line
import { CgbCardRowBlockPreview } from "../components/blocks/CgbCardRowBlock" // eslint-disable-line
import { CgbContactBannerBlockPreview } from "../components/blocks/CgbContactBannerBlock" // eslint-disable-line
import { CgbContactFormBlockPreview } from "../components/blocks/CgbContactFormBlock" // eslint-disable-line
import { CgbFileListBlockPreview } from "../components/blocks/CgbFileListBlock" // eslint-disable-line
import { CgbFileListInnerBlockPreview } from "../components/blocks/CgbFileListInnerBlock" // eslint-disable-line
import { CgbFileListInnerSmallBlockPreview } from "../components/blocks/CgbFileListInnerSmallBlock" // eslint-disable-line
import { CgbGoodToGoBlockPreview } from "../components/blocks/CgbGoodToGoBlock" // eslint-disable-line
import { CgbIconListBlockPreview } from "../components/blocks/CgbIconListBlock" // eslint-disable-line
import { CgbIconListIntroBlockPreview } from "../components/blocks/CgbIconListIntroBlock" // eslint-disable-line
import { CgbIconListInnerBlockPreview } from "../components/blocks/CgbIconListInnerBlock" // eslint-disable-line
import { CgbImageSliderBlockPreview } from "../components/blocks/CgbImageSliderBlock" // eslint-disable-line
import { CgbImageBreakdownBlockPreview } from "../components/blocks/CgbImageBreakdownBlock" // eslint-disable-line
import { CgbImageBreakdownInnerBlockPreview } from "../components/blocks/CgbImageBreakdownInnerBlock" // eslint-disable-line
import { CgbImageGalleryGridBlockPreview } from "../components/blocks/CgbImageGalleryGridBlock" // eslint-disable-line
import { CgbImageGalleryGridInnerLargeBlockPreview } from "../components/blocks/CgbImageGalleryGridInnerLargeBlock" // eslint-disable-line
import { CgbImageGalleryGridInnerSmallBlockPreview } from "../components/blocks/CgbImageGalleryGridInnerSmallBlock" // eslint-disable-line
import { CgbImageLinkSliderBlockPreview } from "../components/blocks/CgbImageLinkSliderBlock" // eslint-disable-line
import { CgbImageLinkSliderInnerBlockPreview } from "../components/blocks/CgbImageLinkSliderInnerBlock" // eslint-disable-line
import { CgbIntroGalleryBlockPreview } from "../components/blocks/CgbIntroGalleryBlock" // eslint-disable-line
import { CgbIntroGallerySplitBlockPreview } from "../components/blocks/CgbIntroGallerySplitBlock" // eslint-disable-line
import { CgbIntroImageSliderBlockPreview } from "../components/blocks/CgbIntroImageSliderBlock" // eslint-disable-line
import { CgbLatestPostsBlockPreview } from "../components/blocks/CgbLatestPostsBlock" // eslint-disable-line
import { CgbNextPreviousPostsBlockPreview } from "../components/blocks/CgbNextPreviousPostsBlock" // eslint-disable-line
import { CgbOfferGridBlockPreview } from "../components/blocks/CgbOfferGridBlock" // eslint-disable-line
import { CgbOfferGridInnerBlockPreview } from "../components/blocks/CgbOfferGridInnerBlock" // eslint-disable-line
import { CgbOpeningTimesBlockPreview } from "../components/blocks/CgbOpeningTimesBlock" // eslint-disable-line
import { CgbPullquoteBlockPreview } from "../components/blocks/CgbPullquoteBlock" // eslint-disable-line
import { CgbPubListingBlockPreview } from "../components/blocks/CgbPubListingBlock" // eslint-disable-line
import { CgbSocialSharingBlockPreview } from "../components/blocks/CgbSocialSharingBlock" // eslint-disable-line
import { CgbThinIntroBlockPreview } from "../components/blocks/CgbThinIntroBlock" // eslint-disable-line
import { CgbThickIntroBlockPreview } from "../components/blocks/CgbThickIntroBlock" // eslint-disable-line
import { CgbTwoCardIntroBlockPreview } from "../components/blocks/CgbTwoCardIntroBlock" // eslint-disable-line
import { CgbTwoColIntroBlockPreview } from "../components/blocks/CgbTwoColIntroBlock" // eslint-disable-line
import { CgbBlogPagePostsBlockPreview } from "../components/blocks/CgbBlogPagePostsBlock" // eslint-disable-line
import { CgbVideoBannerMessageBlockPreview } from "../components/blocks/CgbVideoBannerMessageBlock" // eslint-disable-line
import { CgbVideoEmbedBlockPreview } from "../components/blocks/CgbVideoEmbedBlock" // eslint-disable-line
import { CgbAccommodationBannerBlockPreview } from "../components/blocks/CgbAccommodationBannerBlock" // eslint-disable-line
import { CgbAccommodationFeaturedRoomsBlockPreview } from "../components/blocks/CgbAccommodationFeaturedRoomsBlock" // eslint-disable-line
import { CgbAccommodationFeaturedRoomsInnerBlockPreview } from "../components/blocks/CgbAccommodationFeaturedRoomsInnerBlock" // eslint-disable-line
import { CgbAccommodationIntroBlockPreview } from "../components/blocks/CgbAccommodationIntroBlock" // eslint-disable-line
import { CgbAccommodationRoomListBlockPreview } from "../components/blocks/CgbAccommodationRoomListBlock" // eslint-disable-line
import { CgbAccommodationOtherRoomsBlockPreview } from "../components/blocks/CgbAccommodationOtherRoomsBlock" // eslint-disable-line
import { GravityformsFormBlockPreview } from "../components/blocks/GravityformsFormBlock" // eslint-disable-line
import { CgbSignupGateFormBlockPreview } from "../components/blocks/CgbSignupGateFormBlock" // eslint-disable-line

import { AcfBrewGalleryBlockFragment } from "../components/blocks/AcfBrewGalleryBlock" // eslint-disable-line
import { AcfBrewGalleryBlockPreview } from "../components/blocks/AcfBrewGalleryBlock" // eslint-disable-line
import { AcfAwardRowBlockFragment } from "../components/blocks/AcfAwardRowBlock" // eslint-disable-line
import { AcfAwardRowBlockPreview } from "../components/blocks/AcfAwardRowBlock" // eslint-disable-line
import { AcfContactFormWeddingBlockFragment } from "../components/blocks/AcfContactFormWeddingBlock" // eslint-disable-line
import { AcfContactFormWeddingBlockPreview } from "../components/blocks/AcfContactFormWeddingBlock" // eslint-disable-line
import { AcfFaqsBlockFragment } from "../components/blocks/AcfFaqsBlock"
import { AcfFaqsBlockPreview } from "../components/blocks/AcfFaqsBlock"
import { AcfGridSliderGalleryBlockFragment } from "../components/blocks/AcfGridSliderGalleryBlock" // eslint-disable-line
import { AcfGridSliderGalleryBlockPreview } from "../components/blocks/AcfGridSliderGalleryBlock" // eslint-disable-line
import { AcfIconRowBlockFragment } from "../components/blocks/AcfIconRowBlock" // eslint-disable-line
import { AcfIconRowBlockPreview } from "../components/blocks/AcfIconRowBlock" // eslint-disable-line
import { AcfIconRowInnerBlockFragment } from "../components/blocks/AcfIconRowInnerBlock" // eslint-disable-line
import { AcfIconRowInnerBlockPreview } from "../components/blocks/AcfIconRowInnerBlock" // eslint-disable-line
import { AcfIframeEmbedBlockFragment } from "../components/blocks/AcfIframeEmbedBlock" // eslint-disable-line
import { AcfIframeEmbedBlockPreview } from "../components/blocks/AcfIframeEmbedBlock" // eslint-disable-line
import { AcfImageContentSplitBlockFragment } from "../components/blocks/AcfImageContentSplitBlock" // eslint-disable-line
import { AcfImageContentSplitBlockPreview } from "../components/blocks/AcfImageContentSplitBlock" // eslint-disable-line
import { AcfIntroGalleryMixedBlockFragment } from "../components/blocks/AcfIntroGalleryMixedBlock" // eslint-disable-line
import { AcfIntroGalleryMixedBlockPreview } from "../components/blocks/AcfIntroGalleryMixedBlock" // eslint-disable-line
import { AcfIntroGalleryTwoMixedBlockFragment } from "../components/blocks/AcfIntroGalleryTwoMixedBlock" // eslint-disable-line
import { AcfIntroGalleryTwoMixedBlockPreview } from "../components/blocks/AcfIntroGalleryTwoMixedBlock" // eslint-disable-line
import { AcfIntroGalleryPortraitBlockFragment } from "../components/blocks/AcfIntroGalleryPortraitBlock" // eslint-disable-line
import { AcfIntroGalleryPortraitBlockPreview } from "../components/blocks/AcfIntroGalleryPortraitBlock" // eslint-disable-line
import { AcfIntroGallerySquareBlockFragment } from "../components/blocks/AcfIntroGallerySquareBlock" // eslint-disable-line
import { AcfIntroGallerySquareBlockPreview } from "../components/blocks/AcfIntroGallerySquareBlock" // eslint-disable-line
import { AcfIssuuBlockFragment } from "../components/blocks/AcfIssuuBlock" // eslint-disable-line
import { AcfIssuuBlockPreview } from "../components/blocks/AcfIssuuBlock" // eslint-disable-line
import { AcfTestimonialSliderBlockFragment } from "../components/blocks/AcfTestimonialSliderBlock" // eslint-disable-line
import { AcfTestimonialSliderBlockPreview } from "../components/blocks/AcfTestimonialSliderBlock" // eslint-disable-line
import { AcfTestimonialSliderInnerBlockFragment } from "../components/blocks/AcfTestimonialSliderInnerBlock" // eslint-disable-line
import { AcfTestimonialSliderInnerBlockPreview } from "../components/blocks/AcfTestimonialSliderInnerBlock" // eslint-disable-line
import { AcfTextBackgroundBlockFragment } from "../components/blocks/AcfTextBackgroundBlock" // eslint-disable-line
import { AcfTextBackgroundBlockPreview } from "../components/blocks/AcfTextBackgroundBlock" // eslint-disable-line
import { AcfTimedContainerBlockFragment } from "../components/blocks/AcfTimedContainerBlock" // eslint-disable-line
import { AcfTimedContainerBlockPreview } from "../components/blocks/AcfTimedContainerBlock" // eslint-disable-line
import { AcfTwoColumnStackedBlockFragment } from "../components/blocks/AcfTwoColumnStackedBlock" // eslint-disable-line
import { AcfTwoColumnStackedBlockPreview } from "../components/blocks/AcfTwoColumnStackedBlock" // eslint-disable-line
import { AcfVideoIntroBlockFragment } from "../components/blocks/AcfVideoIntroBlock" // eslint-disable-line
import { AcfVideoIntroBlockPreview } from "../components/blocks/AcfVideoIntroBlock" // eslint-disable-line
import { AcfTenKitesMenusBlockFragment } from "../components/blocks/AcfTenKitesMenusBlock" // eslint-disable-line
import { AcfTenKitesMenusBlockPreview } from "../components/blocks/AcfTenKitesMenusBlock" // eslint-disable-line

export const CoreFields = graphql`
  fragment CoreFields on wp_Block {
    name
    ...CoreParagraphBlock
    ...CoreHeadingBlock
    ...CoreImageBlock
    ...CoreColumnBlock
    ...CoreColumnsBlock
    ...CoreButtonsBlock
    ...CoreButtonBlock
    ...CoreGalleryBlock
    ...CgbQuoteBlock
    ...CoreListBlock
    ...CoreListItemBlock
    ...CoreTableBlock
    ...CoreFileBlock
    ...CoreSpacerBlock
    ...CgbAccordionBlock
    ...CgbAccordionInnerBlock
    ...CgbBannerMessageBlock
    ...CgbBannerCalloutCtaBlock
    ...CgbCalloutCtaBlock
    ...CgbCardBlock
    ...CgbCardRowBlock
    ...CgbContactBannerBlock
    ...CgbContactFormBlock
    ...CgbFileListBlock
    ...CgbFileListInnerBlock
    ...CgbFileListInnerSmallBlock
    ...CgbGoodToGoBlock
    ...CgbIconListIntroBlock
    ...CgbIconListInnerBlock
    ...CgbIconListBlock
    ...CgbImageBreakdownBlock
    ...CgbImageBreakdownInnerBlock
    ...CgbImageGalleryGridBlock
    ...CgbImageGalleryGridInnerLargeBlock
    ...CgbImageGalleryGridInnerSmallBlock
    ...CgbImageLinkSliderBlock
    ...CgbImageLinkSliderInnerBlock
    ...CgbIntroGalleryBlock
    ...CgbIntroGallerySplitBlock
    ...CgbIntroImageSliderBlock
    ...CgbNextPreviousPostsBlock
    ...CgbOfferGridBlock
    ...CgbOfferGridInnerBlock
    ...CgbOpeningTimesBlock
    ...CgbPubListingBlock
    ...CgbPullquoteBlock
    ...CgbSocialSharingBlock
    ...CgbThinIntroBlock
    ...CgbThickIntroBlock
    ...CgbTwoCardIntroBlock
    ...CgbTwoColIntroBlock
    ...CgbBlogPagePostsBlock
    ...CgbVideoEmbedBlock
    ...CgbAccommodationBannerBlock
    ...CgbAccommodationIntroBlock
    ...CgbAccommodationFeaturedRoomsBlock
    ...CgbAccommodationFeaturedRoomsInnerBlock
    ...CgbAccommodationRoomListBlock
    ...CgbBreakoutGalleryIntroBlock
    ...CgbImageSliderBlock
    ...CgbVideoBannerMessageBlock
    ...CgbLatestPostsBlock
    ...CgbAccommodationOtherRoomsBlock
    ...CgbBlogPostWrapBlock
    ...CgbBreakoutGalleryIntroBlock
    ...GravityformsFormBlock
    ...AcfTimedContainerBlock
    ...AcfAwardRowBlock
    ...AcfBrewGalleryBlock
    ...AcfContactFormWeddingBlock
    ...AcfFaqsBlock
    ...AcfGridSliderGalleryBlock
    ...AcfIconRowBlock
    ...AcfIconRowInnerBlock
    ...AcfIframeEmbedBlock
    ...AcfImageContentSplitBlock
    ...AcfIntroGalleryMixedBlock
    ...AcfIntroGalleryTwoMixedBlock
    ...AcfIntroGallerySquareBlock
    ...AcfVideoIntroBlock
    ...AcfTestimonialSliderBlock
    ...AcfTestimonialSliderInnerBlock
    ...AcfTextBackgroundBlock
    ...AcfTwoColumnStackedBlock
    ...AcfIntroGalleryPortraitBlock
    ...AcfIssuuBlock
    ...CgbSignupGateFormBlock
    ...AcfTenKitesMenusBlock
    innerBlocks {
      name
      ...CoreParagraphBlock
      ...CoreHeadingBlock
      ...CoreImageBlock
      ...CoreColumnBlock
      ...CoreColumnsBlock
      ...CoreButtonsBlock
      ...CoreButtonBlock
      ...CoreGalleryBlock
      ...CgbQuoteBlock
      ...CoreListBlock
      ...CoreListItemBlock
      ...CoreTableBlock
      ...CoreFileBlock
      ...CoreSpacerBlock
      ...CgbAccordionBlock
      ...CgbAccordionInnerBlock
      ...CgbBannerMessageBlock
      ...CgbBannerCalloutCtaBlock
      ...CgbCalloutCtaBlock
      ...CgbCardBlock
      ...CgbCardRowBlock
      ...CgbContactBannerBlock
      ...CgbContactFormBlock
      ...CgbFileListBlock
      ...CgbFileListInnerBlock
      ...CgbFileListInnerSmallBlock
      ...CgbIconListIntroBlock
      ...CgbIconListInnerBlock
      ...CgbIconListBlock
      ...AcfIframeEmbedBlock
      ...CgbImageBreakdownBlock
      ...CgbImageBreakdownInnerBlock
      ...CgbImageGalleryGridBlock
      ...CgbImageGalleryGridInnerLargeBlock
      ...CgbImageGalleryGridInnerSmallBlock
      ...CgbImageLinkSliderBlock
      ...CgbImageLinkSliderInnerBlock
      ...CgbIntroGalleryBlock
      ...CgbIntroGallerySplitBlock
      ...CgbIntroImageSliderBlock
      ...CgbNextPreviousPostsBlock
      ...CgbOfferGridBlock
      ...CgbOfferGridInnerBlock
      ...CgbOpeningTimesBlock
      ...CgbPullquoteBlock
      ...CgbSocialSharingBlock
      ...CgbThinIntroBlock
      ...CgbThickIntroBlock
      ...CgbTwoCardIntroBlock
      ...CgbTwoColIntroBlock
      ...CgbBlogPagePostsBlock
      ...CgbVideoEmbedBlock
      ...CgbAccommodationBannerBlock
      ...CgbAccommodationIntroBlock
      ...CgbAccommodationFeaturedRoomsBlock
      ...CgbAccommodationFeaturedRoomsInnerBlock
      ...CgbAccommodationRoomListBlock
      ...CgbBreakoutGalleryIntroBlock
      ...CgbLatestPostsBlock
      ...CgbImageSliderBlock
      ...CgbAccommodationOtherRoomsBlock
      ...CgbBlogPostWrapBlock
      ...CgbBreakoutGalleryIntroBlock
      ...GravityformsFormBlock
      ...AcfTimedContainerBlock
      ...AcfAwardRowBlock
      ...AcfBrewGalleryBlock
      ...AcfContactFormWeddingBlock
      ...AcfFaqsBlock
      ...AcfGridSliderGalleryBlock
      ...AcfIconRowBlock
      ...AcfIconRowInnerBlock
      ...AcfImageContentSplitBlock
      ...AcfIntroGalleryMixedBlock
      ...AcfIntroGalleryTwoMixedBlock
      ...AcfIntroGallerySquareBlock
      ...AcfVideoIntroBlock
      ...AcfTestimonialSliderBlock
      ...AcfTestimonialSliderInnerBlock
      ...AcfTextBackgroundBlock
      ...AcfTwoColumnStackedBlock
      ...AcfIntroGalleryPortraitBlock
      ...AcfIssuuBlock
      ...CgbSignupGateFormBlock
      ...AcfTenKitesMenusBlock
      innerBlocks {
        name
        ...CoreParagraphBlock
        ...CoreHeadingBlock
        ...CoreImageBlock
        ...CoreColumnBlock
        ...CoreColumnsBlock
        ...CoreButtonsBlock
        ...CoreButtonBlock
        ...CoreGalleryBlock
        ...CgbQuoteBlock
        ...CoreListBlock
        ...CoreListItemBlock
        ...CoreTableBlock
        ...CoreFileBlock
        ...CoreSpacerBlock
        ...CgbAccordionBlock
        ...CgbAccordionInnerBlock
        ...CgbBannerMessageBlock
        ...CgbBannerCalloutCtaBlock
        ...CgbCalloutCtaBlock
        ...CgbCardBlock
        ...CgbCardRowBlock
        ...CgbContactBannerBlock
        ...CgbContactFormBlock
        ...CgbFileListBlock
        ...CgbFileListInnerBlock
        ...CgbFileListInnerSmallBlock
        ...CgbIconListIntroBlock
        ...CgbIconListInnerBlock
        ...CgbIconListBlock
        ...AcfIframeEmbedBlock
        ...CgbImageBreakdownBlock
        ...CgbImageBreakdownInnerBlock
        ...CgbImageGalleryGridBlock
        ...CgbImageGalleryGridInnerLargeBlock
        ...CgbImageGalleryGridInnerSmallBlock
        ...CgbImageLinkSliderBlock
        ...CgbImageLinkSliderInnerBlock
        ...CgbIntroGalleryBlock
        ...CgbIntroGallerySplitBlock
        ...CgbIntroImageSliderBlock
        ...CgbNextPreviousPostsBlock
        ...CgbOfferGridBlock
        ...CgbOfferGridInnerBlock
        ...CgbOpeningTimesBlock
        ...CgbPullquoteBlock
        ...CgbSocialSharingBlock
        ...CgbThinIntroBlock
        ...CgbThickIntroBlock
        ...CgbTwoCardIntroBlock
        ...CgbTwoColIntroBlock
        ...CgbBlogPagePostsBlock
        ...CgbVideoEmbedBlock
        ...CgbAccommodationBannerBlock
        ...CgbAccommodationIntroBlock
        ...CgbAccommodationFeaturedRoomsBlock
        ...CgbAccommodationFeaturedRoomsInnerBlock
        ...CgbAccommodationRoomListBlock
        ...CgbBreakoutGalleryIntroBlock
        ...CgbLatestPostsBlock
        ...CgbImageSliderBlock
        ...CgbAccommodationOtherRoomsBlock
        ...CgbBlogPostWrapBlock
        ...CgbBreakoutGalleryIntroBlock
        ...GravityformsFormBlock
        ...AcfTimedContainerBlock
        ...AcfBrewGalleryBlock
        ...AcfContactFormWeddingBlock
        ...AcfFaqsBlock
        ...AcfGridSliderGalleryBlock
        ...AcfIconRowBlock
        ...AcfIconRowInnerBlock
        ...AcfIframeEmbedBlock
        ...AcfImageContentSplitBlock
        ...AcfIntroGalleryMixedBlock
        ...AcfIntroGalleryTwoMixedBlock
        ...AcfIntroGallerySquareBlock
        ...AcfVideoIntroBlock
        ...AcfTestimonialSliderBlock
        ...AcfTestimonialSliderInnerBlock
        ...AcfTextBackgroundBlock
        ...AcfTwoColumnStackedBlock
        ...AcfIntroGalleryPortraitBlock
        ...AcfIssuuBlock
        ...CgbSignupGateFormBlock
        ...AcfTenKitesMenusBlock
        innerBlocks {
          name
          ...CoreParagraphBlock
          ...CoreHeadingBlock
          ...CoreImageBlock
          ...CoreColumnBlock
          ...CoreColumnsBlock
          ...CoreButtonsBlock
          ...CoreButtonBlock
          ...CoreGalleryBlock
          ...CgbQuoteBlock
          ...CoreListBlock
          ...CoreListItemBlock
          ...CoreTableBlock
          ...CoreFileBlock
          ...CoreSpacerBlock
          ...CgbAccordionBlock
          ...CgbAccordionInnerBlock
          ...CgbBannerMessageBlock
          ...CgbBannerCalloutCtaBlock
          ...CgbCalloutCtaBlock
          ...CgbCardBlock
          ...CgbCardRowBlock
          ...CgbContactBannerBlock
          ...CgbContactFormBlock
          ...CgbFileListBlock
          ...CgbFileListInnerBlock
          ...CgbFileListInnerSmallBlock
          ...CgbIconListIntroBlock
          ...CgbIconListInnerBlock
          ...CgbIconListBlock
          ...CgbImageBreakdownBlock
          ...CgbImageBreakdownInnerBlock
          ...CgbImageGalleryGridBlock
          ...CgbImageGalleryGridInnerLargeBlock
          ...CgbImageGalleryGridInnerSmallBlock
          ...CgbImageLinkSliderBlock
          ...CgbImageLinkSliderInnerBlock
          ...CgbIntroGalleryBlock
          ...CgbIntroGallerySplitBlock
          ...CgbIntroImageSliderBlock
          ...CgbOfferGridBlock
          ...CgbOfferGridInnerBlock
          ...CgbOpeningTimesBlock
          ...CgbPullquoteBlock
          ...CgbSocialSharingBlock
          ...CgbThinIntroBlock
          ...CgbThickIntroBlock
          ...CgbTwoCardIntroBlock
          ...CgbTwoColIntroBlock
          ...CgbBlogPagePostsBlock
          ...CgbVideoEmbedBlock
          ...CgbAccommodationBannerBlock
          ...CgbAccommodationIntroBlock
          ...CgbAccommodationFeaturedRoomsBlock
          ...CgbAccommodationFeaturedRoomsInnerBlock
          ...CgbAccommodationRoomListBlock
          ...CgbBreakoutGalleryIntroBlock
          ...CgbLatestPostsBlock
          ...CgbImageSliderBlock
          ...CgbAccommodationOtherRoomsBlock
          ...CgbBlogPostWrapBlock
          ...CgbBreakoutGalleryIntroBlock
          ...GravityformsFormBlock
          ...AcfTimedContainerBlock
          ...AcfAwardRowBlock
          ...AcfBrewGalleryBlock
          ...AcfContactFormWeddingBlock
          ...AcfFaqsBlock
          ...AcfGridSliderGalleryBlock
          ...AcfIconRowBlock
          ...AcfIconRowInnerBlock
          ...AcfIframeEmbedBlock
          ...AcfImageContentSplitBlock
          ...AcfIntroGalleryMixedBlock
          ...AcfIntroGalleryTwoMixedBlock
          ...AcfIntroGallerySquareBlock
          ...AcfVideoIntroBlock
          ...AcfTestimonialSliderBlock
          ...AcfTestimonialSliderInnerBlock
          ...AcfTextBackgroundBlock
          ...AcfTwoColumnStackedBlock
          ...AcfIntroGalleryPortraitBlock
          ...AcfIssuuBlock
          ...CgbSignupGateFormBlock
          ...AcfTenKitesMenusBlock
        }
      }
    }
  }
`

export const PreviewBlocks = `
  ${CoreParagraphBlockPreview}
  ${CoreHeadingBlockPreview}
  ${CoreColumnBlockPreview}
  ${CoreColumnsBlockPreview}
  ${CoreImageBlockPreview}
  ${CoreButtonsBlockPreview}
  ${CoreButtonBlockPreview}
  ${CoreGalleryBlockPreview}
  ${CoreGalleryBlockPreview}
  ${CgbQuoteBlockPreview}
  ${CoreListBlockPreview}
  ${CoreListItemBlockPreview}
  ${CoreTableBlockPreview}
  ${CoreFileBlockPreview}
  ${CoreSpacerBlockPreview}
  ${CgbAccordionBlockPreview}
  ${CgbAccordionInnerBlockPreview}
  ${CgbBannerCalloutCtaBlockPreview}
  ${CgbBannerMessageBlockPreview}
  ${CgbBreakoutGalleryIntroBlockPreview}
  ${CgbCalloutCtaBlockPreview}
  ${CgbCardBlockPreview}
  ${CgbCardRowBlockPreview}
  ${CgbContactBannerBlockPreview}
  ${CgbContactFormBlockPreview}
  ${CgbFileListBlockPreview}
  ${CgbFileListInnerBlockPreview}
  ${CgbFileListInnerSmallBlockPreview}
  ${CgbGoodToGoBlockPreview}
  ${CgbIconListBlockPreview}
  ${CgbIconListInnerBlockPreview}
  ${CgbIconListIntroBlockPreview}
  ${CgbImageSliderBlockPreview}
  ${CgbImageBreakdownBlockPreview}
  ${CgbImageBreakdownInnerBlockPreview}
  ${CgbBlogPostWrapBlockPreview}
  ${CgbImageGalleryGridBlockPreview}
  ${CgbImageGalleryGridInnerLargeBlockPreview}
  ${CgbImageGalleryGridInnerSmallBlockPreview}
  ${CgbImageLinkSliderBlockPreview}
  ${CgbImageLinkSliderInnerBlockPreview}
  ${CgbIntroImageSliderBlockPreview}
  ${CgbIntroGalleryBlockPreview}
  ${CgbIntroGallerySplitBlockPreview}
  ${CgbLatestPostsBlockPreview}
  ${CgbNextPreviousPostsBlockPreview}
  ${CgbOfferGridBlockPreview}
  ${CgbOfferGridInnerBlockPreview}
  ${CgbOpeningTimesBlockPreview}
  ${CgbPubListingBlockPreview}
  ${CgbPullquoteBlockPreview}
  ${CgbSocialSharingBlockPreview}
  ${CgbThinIntroBlockPreview}
  ${CgbThickIntroBlockPreview}
  ${CgbTwoCardIntroBlockPreview}
  ${CgbTwoColIntroBlockPreview}
  ${CgbBlogPagePostsBlockPreview}
  ${CgbVideoBannerMessageBlockPreview}
  ${CgbVideoEmbedBlockPreview}
  ${CgbAccommodationBannerBlockPreview}
  ${CgbAccommodationFeaturedRoomsBlockPreview}
  ${CgbAccommodationFeaturedRoomsInnerBlockPreview}
  ${CgbAccommodationIntroBlockPreview}
  ${CgbAccommodationRoomListBlockPreview}
  ${CgbAccommodationOtherRoomsBlockPreview}
  ${GravityformsFormBlockPreview}
  ${AcfTimedContainerBlockPreview}
  ${AcfAwardRowBlockPreview}
  ${AcfBrewGalleryBlockPreview}
  ${AcfContactFormWeddingBlockPreview}
  ${AcfFaqsBlockPreview}
  ${AcfGridSliderGalleryBlockPreview}
  ${AcfIconRowBlockPreview}
  ${AcfIconRowInnerBlockPreview}
  ${AcfIframeEmbedBlockPreview}
  ${AcfImageContentSplitBlockPreview}
  ${AcfIntroGalleryMixedBlockPreview}
  ${AcfIntroGalleryTwoMixedBlockPreview}
  ${AcfIntroGallerySquareBlockPreview}
  ${AcfIssuuBlockPreview}
  ${AcfVideoIntroBlockPreview}
  ${AcfTestimonialSliderBlockPreview}
  ${AcfTestimonialSliderInnerBlockPreview}
  ${AcfTextBackgroundBlockPreview}
  ${AcfTwoColumnStackedBlockPreview}
  ${AcfIntroGalleryPortraitBlockPreview}
  ${CgbSignupGateFormBlockPreview}
  ${AcfTenKitesMenusBlockPreview}
  `
